
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalError as ObiBatteryVerticalErrorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-error.js';
 
 
 

 
 export const ObiBatteryVerticalError = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-error',
   elementClass: ObiBatteryVerticalErrorElement,
   events: {
     
   }
  });
 
 